import { Location } from 'history';
import { GOOGLE_ANALYTICS_ID } from 'acscp/settings/appSettings';

interface AnalyticsHelper {
    trackLocation(location: Location): void;
}

class NoopAnalyticsHelper implements AnalyticsHelper {
    trackLocation(location: Location): void {}
}

class WebAnalyticsHelper implements  AnalyticsHelper {
    private readonly gtag: any;
    private readonly trackerId: string;

    constructor(gtag: any, trackerId: string) {
        this.gtag = gtag;
        this.trackerId = trackerId;
    }

    trackLocation(location: Location): void {
        this.gtag('config', this.trackerId, {page_path: locationToString(location)});
    }
}

class FirebaseAnalyticsHelper implements AnalyticsHelper {
    private readonly firebasePlugin: any;

    constructor(firebasePlugin: any) {
        this.firebasePlugin = firebasePlugin;
    }

    trackLocation(location: Location): void {
        this.firebasePlugin.logEvent(
            'select_content',
            {content_type: 'page_view', item_id: locationToString(location)}
        );
    }
}

function locationToString(location: Location): string {
    return location.pathname + (location.search || '') + (location.hash || '');
}

function getAnalyticsHelper(): AnalyticsHelper {
    const windowAny = window as any;

    if (windowAny.gtag && typeof windowAny.gtag === 'function' && GOOGLE_ANALYTICS_ID !== '') {
        return new WebAnalyticsHelper(windowAny.gtag, GOOGLE_ANALYTICS_ID);
    }

    if (windowAny.FirebasePlugin) {
        return new FirebaseAnalyticsHelper(windowAny.FirebasePlugin);
    }

    return new NoopAnalyticsHelper();
}

export default getAnalyticsHelper;
